import React, { useState } from 'react';
import ApiClient from '../../../api/apiClient';
import { useAuth } from '../../../context/AuthContext';
import './AddPhase.css';

const AddPhase = ({ show, onClose, onPhaseAdded }) => {
  const [phaseName, setPhaseName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const { user } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phaseName) {
      setError('Environment name is required');
      return;
    }

    try {
      const response = await ApiClient.post('/api/env', { name: phaseName, organization: user?.organization || 'default' });
      if (response.status === 201) {
        setSuccess('Environment added successfully');
        setPhaseName('');
        onPhaseAdded(); // Notify parent to refresh phases
        setTimeout(() => setSuccess(''), 3000); // Hide success message after 3 seconds
        onClose();
      }
    } catch (err) {
      console.error('Error adding Environments:', err);
      if (err.response && err.response.status === 400 && err.response.data.message === 'Phase already exists') {
        setError('Environment already exists');
      } else {
        setError('Error adding Environments');
      }
      setTimeout(() => setError(''), 3000); // Hide error message after 3 seconds
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Add New Environment</h2>
        {error && <div className="notification error">{error}</div>}
        {success && <div className="notification success">{success}</div>}
        <form onSubmit={handleSubmit}>
          <label>
            Environment Name
            <input
              type="text"
              value={phaseName}
              onChange={(e) => setPhaseName(e.target.value)}
              placeholder="e.g. Production"
              required
            />
          </label>
          <div className="modal-actions">
            <button type="button" className="ghost-button" onClick={onClose}>Cancel</button>
            <button type="submit" className="submit-button2">Add Environment</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPhase;
